import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Input, message, Button } from "antd";
import { cookies } from '../../utils';
import { ssoUrl } from "../../common/baseConfig";
import $ from "jquery";
export class LoginByCard extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleCardSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      values.IsShowPhone = 0;
      values.LoginType = 1;
      if (!err) {
        //身份证登录
        this.props.actions.fetchLogin(values).then(res => {
          if (res.SuccessResponse) {
            const { StuID, Name, Phone, System_Station_ID } = res.Data
            this.props.actions.fetchStudentBasics({ StuID })
            message.success(res.Message);
            cookies.setCookie('UserKey', StuID);
            cookies.setCookie('UserNameKey', Name);
            cookies.setCookie('UserPhoneKey', Phone);
            localStorage.setItem('showLoginModal', false);
            localStorage.setItem('studentinfo', JSON.stringify(res.Data));
            //记录登录状态
            let params = {
              'SignInType': 1,
              'Account': values.CardNumber,
              'Password': values.Password,
              'SignInSource': 1,
              'System_Station_ID': System_Station_ID,
            }
            $.ajax({
              type: "POST",
              url: ssoUrl + "/sso/ssostudent/signin",
              data: params,
              xhrFields: { withCredentials: true },
              crossDomain: true,
            });
            //跳转登录
            if (this.props.isNotJump) {
              window.location.reload();
            } else {
              // this.props.actions.fetchCreatePromoter({ PromotersCode: localStorage.getItem('PromotersCode')}).then(res => {
              //   if(res.SuccessResponse){
              //     this.props.history.push('/center');
              //   }else{
              //     message.error(res.Message);
              //   }
              // })
              this.props.history.push('/center');
            }
          }
        });
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="common-login-by-card">
        <Form onSubmit={this.handleCardSubmit} className="login-form">
          <Form.Item>
            {getFieldDecorator('CardNumber', {
              rules: [{ required: true, message: '请输入手机号或者身份证号' }],
            })(
              <Input
                placeholder="手机号/身份证号"
                style={{ height: 40 }}
              />,
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('Password', {
              rules: [{ required: true, message: '请输入密码' }],
            })(
              <Input.Password
                placeholder="密码"
                style={{ height: 40 }}
              />,
            )}
          </Form.Item>
          <Form.Item>
            <Button type="theme" htmlType="submit" className="login-form-button">
              登录
              </Button>
            <p className="forgetpwd" onClick={() => this.props.history.push("/forgetpwd")}>忘记密码</p>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'normal_login_by_card' })(LoginByCard));



// WEBPACK FOOTER //
// ./src/features/common/LoginByCard.js